import { render, staticRenderFns } from "./shopCreate.vue?vue&type=template&id=5f385999&"
import script from "./shopCreate.vue?vue&type=script&lang=js&"
export * from "./shopCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports